import React from 'react';

const IconBusinessProfile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="100%"
    style={{
      width: '100%',
    }}
    viewBox="0 0 97 98"
  >
    <defs>
      <linearGradient id="n6p4fngs1c" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#F8F8F8" />
        <stop offset="100%" stopColor="#F9F9F9" />
      </linearGradient>
      <linearGradient id="utnvguba0d" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#98B0FD" />
        <stop offset="100%" stopColor="#2D60FB" />
      </linearGradient>
      <linearGradient id="ig4udr1zje" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#2D60FB" />
        <stop offset="100%" stopColor="#98B0FD" />
      </linearGradient>
      <linearGradient id="cbbgf87csf" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#2D60FB" />
        <stop offset="100%" stopColor="#98B0FD" />
      </linearGradient>
      <linearGradient id="42jld493rg" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#2D60FB" />
        <stop offset="100%" stopColor="#98B0FD" />
      </linearGradient>
      <linearGradient id="a5uayp22th" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#2D60FB" />
        <stop offset="100%" stopColor="#98B0FD" />
      </linearGradient>
      <linearGradient id="lxbfxhohyi" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#2D60FB" />
        <stop offset="100%" stopColor="#98B0FD" />
      </linearGradient>
      <linearGradient id="ujf2uyk12j" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#2D60FB" />
        <stop offset="100%" stopColor="#98B0FD" />
      </linearGradient>
      <linearGradient id="gwbin7ca8k" x1="50%" x2="50%" y1="-45.26%" y2="100%">
        <stop offset="0%" stopColor="#2D60FB" />
        <stop offset="100%" stopColor="#98B0FD" />
      </linearGradient>
      <filter
        id="9kqi3qhsqa"
        width="106.5%"
        height="106.4%"
        x="-3.2%"
        y="-3.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
      </filter>
      <rect id="ahatozkecb" width="93" height="94" x="0" y="0" rx="23" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-250 -154) translate(252 156)">
            <use
              fill="#000"
              filter="url(#9kqi3qhsqa)"
              xlinkHref="#ahatozkecb"
            />

            <use fill="url(#n6p4fngs1c)" xlinkHref="#ahatozkecb" />
          </g>
          <g>
            <path
              fill="url(#utnvguba0d)"
              d="M8.44 60h56.938c.795 0 1.44-.645 1.44-1.44V20.44c0-.795-.645-1.44-1.44-1.44H8.44C7.645 19 7 19.645 7 20.44v38.12c0 .795.645 1.44 1.44 1.44z"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="#F9F9F9"
              d="M65.824 0L6.825 0 0 18.682 72.108 18.682 65.824 0.397"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#ig4udr1zje)"
              d="M11.525 0L6.585 0 0 18.682 4.939 18.682 11.525 0"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#cbbgf87csf)"
              d="M22.5 0L17.561 0 13.171 18.682 18.11 18.682 22.5 0"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#42jld493rg)"
              d="M33.476 0L28.537 0 26.342 18.682 31.281 18.682 33.476 0"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#a5uayp22th)"
              d="M44.452 0L39.513 0 41.708 18.682 46.647 18.682 44.452 0"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#lxbfxhohyi)"
              d="M55.427 0L50.489 0 54.879 18.682 59.818 18.682 55.427 0"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#ig4udr1zje)"
              d="M66.403 0L61.464 0 68.05 18.682 72.989 18.682 66.403 0"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#ujf2uyk12j)"
              d="M2.475 21.828C1.108 21.828 0 20.726 0 19.365v-.683h4.95v.683c0 1.36-1.108 2.463-2.475 2.463"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="#DAF0F0"
              d="M10.01 21.828h-1.9c-1.745 0-3.16-1.408-3.16-3.146h8.221c0 1.738-1.415 3.146-3.16 3.146"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#gwbin7ca8k)"
              d="M15.646 21.828c-1.367 0-2.475-1.102-2.475-2.463v-.683h4.95v.683c0 1.36-1.108 2.463-2.475 2.463"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="#DAF0F0"
              d="M23.181 21.828h-1.899c-1.746 0-3.161-1.408-3.161-3.146h8.22c0 1.738-1.414 3.146-3.16 3.146"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#ujf2uyk12j)"
              d="M28.817 21.828c-1.367 0-2.475-1.102-2.475-2.463v-.683h4.95v.683c0 1.36-1.108 2.463-2.475 2.463"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="#DAF0F0"
              d="M38.547 21.828h-4.094c-1.746 0-3.16-1.408-3.16-3.146h10.415c0 1.738-1.415 3.146-3.161 3.146"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#ujf2uyk12j)"
              d="M44.183 21.828c-1.367 0-2.475-1.102-2.475-2.463v-.683h4.95v.683c0 1.36-1.108 2.463-2.475 2.463"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="#DAF0F0"
              d="M51.718 21.828h-1.9c-1.744 0-3.16-1.408-3.16-3.146h8.221c0 1.738-1.415 3.146-3.16 3.146"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#ujf2uyk12j)"
              d="M57.354 21.828c-1.367 0-2.475-1.102-2.475-2.463v-.683h4.95v.683c0 1.36-1.108 2.463-2.475 2.463"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="#DAF0F0"
              d="M64.89 21.828h-1.9c-1.746 0-3.16-1.408-3.16-3.146h8.22c0 1.738-1.415 3.146-3.16 3.146"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
            <path
              fill="url(#gwbin7ca8k)"
              d="M70.525 21.828c-1.367 0-2.475-1.102-2.475-2.463v-.683H73v.683c0 1.36-1.108 2.463-2.475 2.463"
              transform="translate(-250 -154) translate(252 156) translate(10 17)"
            />
          </g>
          <g>
            <path
              fill="#FFF"
              d="M0 14.096L2.59 14.096 2.59 0 0 0zM33.41 14.096L36 14.096 36 0 33.41 0z"
              transform="translate(-250 -154) translate(252 156) translate(29 45)"
            />
            <g>
              <path
                fill="#FFF"
                d="M27.372 8.275c.257 0 .505-.034.744-.104.239-.07.45-.192.634-.366s.331-.4.443-.678c.11-.277.167-.63.169-1.057l.001-.427-2.037.321c-.318.05-.584.17-.799.356-.215.187-.323.468-.324.843-.001.285.095.541.29.768.195.227.488.342.88.344zm-3.61-.967c.003-.427.074-.806.216-1.135.142-.33.335-.617.581-.862.246-.244.53-.437.855-.578.325-.141.677-.243 1.056-.307l2.22-.34c.257-.037.435-.117.533-.24.099-.122.148-.268.149-.436.001-.336-.123-.628-.373-.875s-.631-.372-1.145-.374c-.538-.002-.95.151-1.24.46-.288.31-.452.672-.49 1.086l-2.162-.495c.038-.375.15-.75.334-1.125.185-.374.437-.71.756-1.006.32-.296.711-.537 1.177-.723.465-.185 1.004-.277 1.615-.275.71.003 1.314.107 1.815.31.5.202.906.47 1.216.8.311.332.535.718.675 1.159.138.44.207.9.205 1.379l-.018 4.698c-.001.26.01.534.034.826.023.29.046.521.07.69l-2.238-.01c-.024-.13-.044-.308-.061-.535-.018-.226-.026-.43-.026-.611-.234.374-.568.703-1.003.985-.435.283-.99.424-1.662.42-.477-.002-.907-.084-1.292-.248-.384-.163-.71-.378-.979-.645-.268-.266-.471-.571-.61-.915-.14-.343-.209-.702-.207-1.078zM10.561 6.26c-.13.337-.299.618-.508.843-.208.226-.453.396-.735.511-.282.116-.57.173-.863.171-.293 0-.58-.06-.861-.178-.28-.118-.525-.29-.732-.518-.207-.227-.374-.51-.501-.847-.127-.336-.19-.731-.188-1.185.002-.452.068-.847.197-1.183.13-.336.299-.617.508-.842.208-.226.454-.396.735-.512.282-.115.57-.172.863-.17.294 0 .58.06.862.178.28.117.524.29.731.517.207.228.375.51.501.847.127.337.19.732.188 1.185-.001.453-.067.848-.197 1.184m2.3-3.171l-.013-.043c-.236-.622-.564-1.157-.984-1.605-.42-.449-.92-.8-1.5-1.055C9.784.132 9.158.003 8.485 0c-.673-.003-1.3.12-1.881.37-.582.25-1.085.598-1.508 1.042-.424.445-.756.978-.997 1.598-.24.62-.362 1.3-.365 2.037-.003.738.113 1.415.35 2.03.235.616.564 1.152.984 1.606.42.455.92.81 1.5 1.065.58.255 1.206.384 1.878.387.672.003 1.3-.121 1.882-.37.581-.25 1.084-.601 1.508-1.053.423-.45.756-.983.996-1.597.006-.015.01-.032.017-.048-.175-.621-.263-1.285-.26-1.982.003-.7.095-1.368.273-1.995M18.692 2.432c-.318-.001-.614.056-.89.171-.276.115-.518.286-.727.511-.209.226-.375.507-.498.843-.124.336-.186.717-.188 1.145-.002.427.058.809.179 1.146.121.337.288.622.501.856.213.234.457.41.732.528.275.117.57.176.889.178.305.001.578-.046.817-.142.238-.096.443-.221.615-.376s.31-.329.415-.523c.104-.193.182-.38.231-.561l2.144.766c-.1.4-.264.792-.491 1.173-.228.38-.52.723-.875 1.025-.356.303-.773.547-1.25.732-.478.185-1.017.278-1.615.275-.66-.003-1.28-.132-1.86-.387-.58-.255-1.084-.61-1.51-1.065-.426-.454-.76-.99-1.002-1.606-.243-.615-.362-1.293-.36-2.03.004-.738.125-1.417.366-2.037.24-.62.573-1.153.997-1.598.423-.444.92-.792 1.49-1.042.569-.25 1.184-.373 1.844-.37.612.002 1.158.099 1.64.288.483.19.9.435 1.254.734.354.3.64.643.858 1.033.219.389.376.784.473 1.186l-2.186.767c-.108-.401-.318-.771-.629-1.11-.31-.337-.765-.507-1.364-.51"
                transform="translate(-250 -154) translate(252 156) translate(29 45) translate(0 4.257)"
              />
              <path
                fill="#FC0"
                d="M0 17.743L35.637 17.743 35.637 15.161 0 15.161z"
                transform="translate(-250 -154) translate(252 156) translate(29 45) translate(0 4.257)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconBusinessProfile;
